// @ts-ignore
export const SERVER_URL: string = "https://compact-feliza-lop-world-53771867.koyeb.app";


